import React from 'react';
import { Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { unitResponsesStyles } from './styles';

const VcmProfessionalQualificationCode = ({ classes, row }) => {
  const qualification = row.professional_qualification;
  const label = qualification?.title 
    ? `${qualification.code} \u2013 ${qualification.title}` 
    : qualification?.code;
  
  return (
    <div className={classes.cell}>
      <Typography className={classes.body2}>
        {label}
      </Typography>
    </div>
  );
};

export default withStyles(VcmProfessionalQualificationCode, unitResponsesStyles, {
  withTheme: true
});
